// extracted by mini-css-extract-plugin
module.exports = {"InfoIcon":"InfoIcon___2_XpU","loading":"loading___3vIOf"};